<template>
    <div id="dsv-content-wrapper" :class="{ 'top-mode': !isEnhancedLayout }">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "ContentWrapper",
    computed: {
        isEnhancedLayout() {
            return this.$store.state.isEnhancedLayout;
        }
    },
    watch: {
        isEnhancedLayout() {
            // this.reloadContentWrapper();
        }
    },
    mounted() {
        // this.reloadContentWrapper();
    },
    methods: {
        reloadContentWrapper() {
            const value = this.isEnhancedLayout;
            const contentWrapper = document.getElementById(
                "dsv-content-wrapper"
            );

            if (!value) {
                this.$nextTick(() => {
                    const topBarSecondaryWrapperHeight = document.getElementById(
                        "top-bar-secondary-wrapper"
                    ).offsetHeight;

                    const dsvAppTopbarHeight = document.getElementById(
                        "dsv-app-topbar"
                    ).offsetHeight;

                    const totalHeight =
                        topBarSecondaryWrapperHeight + dsvAppTopbarHeight;

                    contentWrapper.style.paddingTop = `${totalHeight}px`;
                });
            } else {
                this.$nextTick(() => {
                    contentWrapper.style.paddingTop = "0px";
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#dsv-content-wrapper {
    &.top-mode {
        padding-top: 0;
    }
}

@media screen and (min-width: 992px) {
    #dsv-content-wrapper {
        &.top-mode {
            $top-bar-primary-height: 64px;
            $top-bar-secondary-height: 50px;
            padding-top: $top-bar-primary-height + $top-bar-secondary-height;
        }
    }
}
</style>